// extracted by mini-css-extract-plugin
export default {"form_control":"TextArea_form_control__yxgmR","dark":"TextArea_dark__4r-Yg"};